import React from "react";
import PropTypes from "prop-types";
import styles from "./Alert.module.scss";
import Button, { ButtonLink } from "../Button/Button";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import clsx from "clsx";
import { CloseIcon } from "../../icons/CloseIcon";

const Alert = ({
  title,
  titleClassName,
  text,
  textClassName,
  className,
  buttonLabel,
  buttonType,
  buttonTestId,
  icon,
  iconClassName,
  onClick,
  onChange,
  onDismiss,
  type,
  center,
  dataTestId,
  toggled,
  toggle,
  toggleLabelColor,
  toggleOffColor,
  toggleLabel,
  disabled,
  href,
}) => {
  const classes = clsx(
    styles.alert,
    type && styles[type.toLowerCase()],
    center && styles.center,
    className
  );
  return (
    <div className={classes} data-testid={dataTestId}>
      {onDismiss ? (
        <div className={styles.close}>
          <CloseIcon onClick={onDismiss} data-testid="DismissButton" />
        </div>
      ) : null}
      <div className="d-flex flex-column">
        <h5 data-testid="AlertTitle" className={titleClassName}>
          {icon ? <span className={clsx(styles.titleIcon, iconClassName)}>{icon}</span> : null}
          {title}
        </h5>
        <span className={textClassName}>{text}</span>
        {onClick || href ? (
          <div className={clsx("mt-4 d-flex", styles.buttonContainer)}>
            {toggle ? (
              <div className={"mt-1"}>
                <ToggleSwitch
                  label={toggleLabel}
                  colorLabel={toggleLabelColor}
                  toggle={toggle}
                  disabled={disabled}
                  toggled={toggled}
                  offColor={toggleOffColor}
                  onChange={onChange}
                />
              </div>
            ) : href ? (
              <ButtonLink
                label={buttonLabel}
                type={buttonType}
                href={href}
                anchorProps={{
                  rel: "noreferrer",
                  target: "_blank",
                }}
              />
            ) : (
              <Button
                label={buttonLabel}
                type={buttonType}
                onClick={onClick}
                dataTestId={buttonTestId}
              />
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const oneOfColor = ["neutral", "primary", "danger", "error"];

Alert.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  titleClassName: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonLabel: PropTypes.string,
  buttonType: PropTypes.string,
  icon: PropTypes.node,
  iconClassName: PropTypes.string,
  onClick: PropTypes.func,
  onDismiss: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string,
  center: PropTypes.bool,
  dataTestId: PropTypes.string,
  buttonTestId: PropTypes.string,
  checked: PropTypes.string,
  toggleLabel: PropTypes.string,
  toggleLabelColor: PropTypes.string,
  toggleOffColor: PropTypes.oneOf(oneOfColor),
  href: PropTypes.string,
};

Alert.defaultProps = {
  type: "Primary",
  dataTestId: "Alert",
};

export default Alert;
